import React from 'react';

const ZoomButton = ({ children, className, handleClick, ariaLabel }) => (
  <div className={className}
    role="button"
    onClick={handleClick}
    tabIndex="0"
    aria-label={ariaLabel}
    onKeyPress={(event) => {
    if(event.key === 'Enter' || event.key === ' '){
      handleClick(event);
    }
  }}>
    { children }
  </div>
);

export default ZoomButton;



// WEBPACK FOOTER //
// ./src/components/ZoomTool/ZoomButton.js